// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React, { useState, useEffect } from 'react'
import { func, array } from 'prop-types'
import Caption from './Caption'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getProtectionMetrics } from 'redux/modules/protection'
import { CarouselControl } from 'reactstrap'

import {
  CarouselItemWrapper,
  CarouselWrapper,
} from './styles'

const ProtectionMetrics = ({ data, getProtectionMetrics }) => {
  const [activeIndex, setActiveIndex] = useState(0)
  const [animating, setAnimating] = useState(false)

  useEffect(() => {
    const initializeComponent = async () => {
      try {
        await getProtectionMetrics()
      } catch (err) {
        console.warn(err)
        // TODO - how to better handle here?
      }
    }

    initializeComponent()
  }, [data])

  const next = () => {
    if (animating) return
    const nextIndex = (activeIndex + 1) % data.length
    setActiveIndex(nextIndex)
  }

  const previous = () => {
    if (animating) return
    const nextIndex = activeIndex ? activeIndex - 1 : data.length - 1
    setActiveIndex(nextIndex)
  }

  return (
    <CarouselWrapper
      className={'d-none d-sm-block'}
      activeIndex={activeIndex}
      next={next}
      previous={previous}
      interval={7000} >
      {(
        data.map((item) => (
          <CarouselItemWrapper
            key={item.banner_group}
            onExiting={() => setAnimating(true)}
            onExited={() => setAnimating(false)} >
            <Caption metrics={item} />
          </CarouselItemWrapper>
        ))
      )}
      <CarouselControl direction={'prev'} onClickHandler={previous} />
      <CarouselControl direction={'next'} onClickHandler={next} />
    </CarouselWrapper>
  )
}

ProtectionMetrics.propTypes = {
  data: array.isRequired,
  getProtectionMetrics: func.isRequired,
}

const mapStateToProps = ({ protection }) => {
  const { data } = protection.protectionMetrics
  return {
    data,
  }
}

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    getProtectionMetrics,
  }, dispatch)
)

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProtectionMetrics)
